import { render, staticRenderFns } from "./insureGuide.vue?vue&type=template&id=4c74ea44&scoped=true"
import script from "./insureGuide.vue?vue&type=script&lang=js"
export * from "./insureGuide.vue?vue&type=script&lang=js"
import style0 from "./insureGuide.vue?vue&type=style&index=0&id=4c74ea44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74ea44",
  null
  
)

export default component.exports